module.exports = "/* Work around for primeng not properly handling view encapsulation.\n   ::ng-deep prevents angular from adding encapsulation tags to children selectors */\n:host ::ng-deep .disabled {\n    color: #999999 !important;\n    /*text-decoration: line-through;*/\n}\n:host ::ng-deep table {\n    table-layout: auto;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/deposit-search/unapproved-remittances/unapproved-remittances.component.css
// module id = ./src/app/components/deposit-search/unapproved-remittances/unapproved-remittances.component.css
// module chunks = main